module.exports = __webpack_public_path__ + "img/yishi3.2007c01b.jpg";